import { Component } from "@angular/core";

@Component({
	selector: "ic-unknown-problem",
	templateUrl: "./unknown-problem.component.html",
	standalone: false,
})
export class UnknownProblemComponent {}
